import React from 'react';
import './octopus.scss';
import { Typography } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Button from '@material-ui/core/Button';

//img
import Twitter from './../../img/icons/footer_twitter.svg';
import Telegram from './../../img/icons/footer_telegram.svg';
import Discord from './../../img/icons/footer_discord.svg';

const Octopus = () => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  // opaque on scroll
  //   const checkpoint = 1000;
  //   var opacity = '';
  //   window.addEventListener('scroll', () => {
  //     const currentScroll = window.pageYOffset;
  //     if (currentScroll <= checkpoint) {
  //       opacity = 1 - currentScroll / checkpoint;
  //     } else {
  //       opacity = 0;
  //     }
  //     document.querySelector('.front').style.opacity = opacity;
  //   });

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        arrow
        PopperProps={{
          disablePortal: true,
        }}
        TransitionComponent={Zoom}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        interactive
        title={
          <div>
            <Typography variant="h6">Request a parley:</Typography>

            <Button
              rel="noreferrer"
              target="_blank"
              href="https://twitter.com/itrustfinance?lang=en"
            >
              <img alt="iTrust on Twitter" src={Twitter} />
              Twitter
            </Button>

            <Button
              rel="noreferrer"
              target="_blank"
              href="https://t.me/iTrustCommunity"
            >
              <img alt="iTrust on Twitter" src={Telegram} />
              Telegram
            </Button>

            <Button
              rel="noreferrer"
              target="_blank"
              href="https://discord.gg/pTre3yYu78"
            >
              <img alt="iTrust on Twitter" src={Discord} />
              Discord
            </Button>
          </div>
        }
      >
        <div onClick={handleTooltipOpen} className="App_octopus">
          <Typography variant="h3">
            <span>?</span>
          </Typography>
        </div>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default Octopus;
